import React from 'react';
import PropTypes from 'prop-types';
import BlogPostBase from '@components/BlogPost';
import * as styles from './BlogPost.module.scss';

import Layout from "@arbol/Layout";
import Footer from "@arbol/Footer";
import ContactForm from "@arbol/ContactForm";
import Seo from "@components/seo";
import { graphql } from 'gatsby';
import { withPrismicPreview } from 'gatsby-plugin-prismic-previews';

const BlogPost = ({ data }) => {
  const page = {
    ...data.prismicNewsPost.data,
    id: data.prismicNewsPost.id,
    tags: data.prismicNewsPost.tags
  };

  return (
    <Layout transparentHeader={false}>
      <BlogPostBase styles={styles} page={page} />
      <ContactForm />
      <Footer />
    </Layout>
  );
};

BlogPost.propTypes = {
  data: PropTypes.object.isRequired
};

export const query = graphql`
  query BlogPost($id: String!) {
    prismicNewsPost(id: { eq: $id }) {
      _previewable
      tags
      id
      data {
        featured
        title {
          text
        }
        intro_text {
          text
        }
        author {
          text
          html
        }
        external_link {
          url
          target
        }
        meta_description {
          text
        }
        author_image {
          url
        }
        main_image {
          url
        }
        small_image {
          url
        }
        body {
          ... on PrismicNewsPostDataBodyRichText {
            id
            slice_type
            items {
              text {
                raw
              }
            }
          }
          ... on PrismicNewsPostDataBodyImage {
            id
            slice_type
            slice_label
            primary {
              image {
                url
              }
            }
          }
          ... on PrismicNewsPostDataBodyQuote {
            id
            slice_type
            primary {
              quote {
                text
              }
            }
          }
        }
      }
    }
  }
`;

export default withPrismicPreview(BlogPost);

export const Head = ({ data }) => {
  const page = {
    ...data.prismicNewsPost.data,
    id: data.prismicNewsPost.id,
    tags: data.prismicNewsPost.tags
  };
  return (
    <Seo 
      title={`${page.title.text} | Arbol by Gomes`} 
      description={page.meta_description && page.meta_description.text}
      ogImage="https://images.prismic.io/bygomes/aJ-VBKTt2nPbaXsE_og_Arbol.jpg"
      ogUrl="https://bygomes.com/property/arbol"
      meta={[
        {
          property: `og:title`,
          content: `Arbol by Gomes | Newark, NJ`,
        },
        {
          property: `og:description`,
          content: `Arbol by Gomes, Newark New Jersey's newest modern apartment concept inspired by nature and built for more than living.`,
        },
      ]}
    />
  );
};

Head.propTypes = {
  data: PropTypes.shape({
    prismicNewsPost: PropTypes.shape({
      data: PropTypes.object.isRequired,
      id: PropTypes.string.isRequired,
      tags: PropTypes.array.isRequired,
    }).isRequired,
  }).isRequired,
};
